import React, { forwardRef } from 'react';
import { motion } from 'framer-motion';
import { Loader2Icon } from 'lucide-react';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger' | 'success';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading,
  leftIcon,
  rightIcon,
  children,
  disabled,
  ...props
}, ref) => {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none rounded-fluent';
  const variants = {
    primary: 'bg-fpg-navy text-white hover:bg-fpg-navy-light focus:ring-fpg-navy',
    secondary: 'bg-surface-primary text-text-primary border border-border-default hover:bg-surface-secondary focus:ring-fpg-navy',
    ghost: 'bg-transparent text-text-primary hover:bg-surface-secondary focus:ring-fpg-navy',
    danger: 'bg-status-error text-white hover:bg-red-600 focus:ring-status-error',
    success: 'bg-fpg-green text-white hover:bg-green-600 focus:ring-fpg-green'
  };
  const sizes = {
    sm: 'text-xs px-3 py-1.5 h-8',
    md: 'text-sm px-4 py-2 h-10',
    lg: 'text-base px-6 py-3 h-12'
  };
  return <motion.button ref={ref} whileTap={disabled || isLoading ? undefined : {
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-166">
        {isLoading && <Loader2Icon className="w-4 h-4 mr-2 animate-spin" data-id="element-167" />}
        {!isLoading && leftIcon && <span className="mr-2" data-id="element-168">{leftIcon}</span>}
        {children}
        {!isLoading && rightIcon && <span className="ml-2" data-id="element-169">{rightIcon}</span>}
      </motion.button>;
});
Button.displayName = 'Button';